<!--下拉框-->
<template>
  <div class="item-box">
    <!--标题-->
    <div :class="['question-item-title',{isMbottom:question.show_rule.is_check_show}]">
      <span :class="{xinxin:question.verify_rule.is_require}">
        <i v-if="!$store.state.settingData.base.notorder">{{ number }}、</i>
        <span class="q-title" v-html="question.title"></span>
        <Icon type="ios-information-circle" @click="hintShowClick" v-if="question.show_rule.is_check_show && question.show_rule.hint.length>0"/>
      </span>
    </div>
    <span class="title-tips" v-html="question.show_rule.hint" v-if="!question.show_rule.is_check_show"></span>
    <div class="select-box q-content">
      <Select size="large"
              @on-change="handerChange"
              v-model="tValue"
              placeholder="请选择">
        <Option
            v-for="item in question.answers.option"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </Option>
      </Select>
    </div>
    <!--提示弹框-->
    <Modal class="hintModel" v-model="modal" width="70%" :closable="false">
      <p slot="header">
        <Icon type="ios-information-circle"></Icon>
        <span>填写提示</span>
      </p>
      <div style="color: #4e4c56;font-size: 16px">
        <span v-html="question.show_rule.hint"></span>
      </div>
      <div slot="footer">
        <p @click="clearClick">我知道了</p>
      </div>
    </Modal>
  </div>
</template>

<script>
    export default {
        name: "tSelect",
        props: {
            question: {
                type: Object,
                default() {
                    return {}
                }
            },
            number: {
                type: Number,
                default() {
                    return 1;
                }
            },
        },
        data() {
            return {
                tValue: '',
                modal: false
            }
        },
        mounted() {
            this.tValue = this.$store.state.user_answers[this.question.id]
        },
        methods: {
            handerChange(val) {
                this.tValue = val
                let obj = {}
                obj[this.question.id] = this.tValue
                this.$store.dispatch('userAnswersActions', obj)
            },
            hintShowClick() {
                this.modal = true
            },
            clearClick() {
                this.modal = false
            }
        }
    }
</script>

<style lang="scss" scoped>
.xinxin {
  position: relative;
  margin-right: 5px;
  padding-left: 8px;
  &:after {
    content: "*";
    display: inline-block;
    margin-right: 4px;
    font-size: 16px;
    color: rgb(255, 51, 0);
    position: absolute;
    top: 0px;
    left: 0px;
  }
}
</style>
